import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

import { clearTravelReservation } from 'models/travelReservation';
import { clearTravelParticipant } from 'models/travelParticipant';

const routes: CustomRoute = {
	path: appPath.travelPayment.replace(appPath.travel, ''),
	components: () => [import(/* webpackChunkName: 'travelPayment' */ './component')],
	render: ([TravelPayment]) => <TravelPayment />,
	onEnter: async ({ store, next }) => {
		store.dispatch(clearTravelParticipant());
		store.dispatch(clearTravelReservation());

		const children = await next();
		return children;
	},
};

export default routes;
